import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const categorySlice = createSlice({
  name: 'categorySliceName',
  initialState,
  reducers: {
    addCategory: () => {

    },
    getCategory: () => {

    },
    getOneCategory: () => {

    },

    successCategory: (state, action) => {

      state.data = action.payload
    },
    removeCategory: () => {
    },
    updateCategory: () => {
    },
    emptyCart: (state, action) => {
      state.value += action.payload
    },
    searchCategoryByName: () => {

    },
    failedCategory: (state, action) => {
      state.value += action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { addCategory, removeCategory, updateCategory, getCategory, successCategory, getOneCategory, searchCategoryByName, failedCategory } = categorySlice.actions

export default categorySlice.reducer